'use client'

import { useEffect, useState } from "react"
import { usePathname } from "next/navigation"
import { Menu } from "lucide-react"
import { Sheet, SheetContent, SheetDescription, SheetHeader, SheetTitle } from "@/components/ui/sheet"

// The page list as a drawer, for screens too narrow for the sidebar. It closes on navigation.
export default function DocsMobileNav({ title, children }: { title: string, children: React.ReactNode }) {
  const [open, setOpen] = useState(false)
  const pathname = usePathname()

  useEffect(() => setOpen(false), [pathname])

  return (
    <>
      <button type="button" onClick={() => setOpen(true)} aria-label={title}
        className="inline-flex size-10 cursor-pointer items-center justify-center rounded-md border border-input transition-colors hover:bg-accent lg:hidden">
        <Menu className="size-5" />
      </button>
      <Sheet open={open} onOpenChange={setOpen}>
        <SheetContent side="left" className="w-72 gap-0 overflow-y-auto">
          <SheetHeader className="border-b">
            <SheetTitle className="font-gilroy">{title}</SheetTitle>
            <SheetDescription className="sr-only">{title}</SheetDescription>
          </SheetHeader>
          <div className="p-3">{children}</div>
        </SheetContent>
      </Sheet>
    </>
  )
}
